import {makeThemeProps} from "@themes/boost/props/utils";

export default (theme, site, options = {}) => {
  const themeStyles = makeThemeProps(theme, site, options);
  return themeStyles.getCategoryBarProps(theme, options, site);
};
